module.exports = __webpack_public_path__ + "img/0xfa000f8dB120e5eCeE912c71bDD8759c8C89877C.feada72a.png";